import { createFileRoute } from "@tanstack/react-router"
import { useTranslation } from "react-i18next"

import { CniPermissionsMatrix } from "@/features/cni-rbac/components/CniPermissionsMatrix"

export const Route = createFileRoute("/_authed/cni/permissions")({
  component: CniPermissionsPage,
})

function CniPermissionsPage() {
  const { t } = useTranslation("cni-rbac")
  return (
    <div className="h-full flex flex-col min-h-0">
      <div className="border-b border-ok-border px-6 py-4 shrink-0">
        <h1 className="text-lg font-semibold tracking-tight">{t("permissionsPage.title")}</h1>
        <p className="text-xs text-ok-foreground-muted">{t("permissionsPage.subtitle")}</p>
      </div>
      <div className="flex-1 min-h-0">
        <CniPermissionsMatrix />
      </div>
    </div>
  )
}
